export const environment = {
  production: false,
  environment: 'dev',
  configUrl: 'https://dev.property-tax-fraud-tracker.oab-aws.com/config',
  apiUrl: 'https://api-dev.property-tax-fraud-tracker.oab-aws.com',
  websocketUrl: 'wss://websocket-dev.property-tax-fraud-tracker.oab-aws.com',
};
//2skms9lz1j.execute-api.eu-west-1.amazonaws.com
//wss://t3pd1wlsaa.execute-api.eu-west-1.amazonaws.com/Prod
